import { clamp } from './chart-data';

// Keep the candle under the pointer at the same horizontal fraction on zoom.
export function zoomWindow(total: number, bars: number, offset: number, fraction: number, factor: number) {
  const nextBars = clamp(Math.round(bars * factor), 20, 500);
  const shown = Math.min(total, bars), nextShown = Math.min(total, nextBars);
  const end = total - offset;
  const anchor = end - shown + clamp(fraction, 0, 1) * shown;
  const nextEnd = anchor + (1 - clamp(fraction, 0, 1)) * nextShown;
  return { bars: nextBars, offset: clamp(Math.round(total - nextEnd), 0, Math.max(0, total - nextShown)) };
}
